export default __webpack_public_path__ + "static/media/baxter.2d85a817.gif";